import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'


export default function NotFoundPage () {
    const { t } = useTranslation()

	return (
		<Container>
			<Row className="text-center py-5">
				<h1>{t('global.pagenotfound')}</h1>
			</Row>
			<Row className="text-center mx-3">
				<h4>{t('global.error404description')}</h4>
				<h4>{t('global.error404')}</h4>
			</Row>
		</Container>
	)
}
